























































import { IRequisition, RequisitionApprovalState } from '@/models';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'RequisitionApproverListMenu',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    }
  },

  methods: {
    moment,

    getApproverStatusColor(status: RequisitionApprovalState) {
      switch (status) {
        case RequisitionApprovalState.TENTATIVE:
          return 'warning';
        case RequisitionApprovalState.APPROVED:
          return 'success darken-1';
        case RequisitionApprovalState.REJECTED:
          return 'error';
      }
    },

    getApproverStatusIcon(status: RequisitionApprovalState) {
      switch (status) {
        case RequisitionApprovalState.TENTATIVE:
          return 'mdi-account-alert-outline';
        case RequisitionApprovalState.APPROVED:
          return 'mdi-account-check-outline';
        case RequisitionApprovalState.REJECTED:
          return 'mdi-account-cancel-outline';
      }
    },

    getApproverStatusText(status: RequisitionApprovalState) {
      switch (status) {
        case RequisitionApprovalState.TENTATIVE:
          return 'Approval Pending';
        case RequisitionApprovalState.APPROVED:
          return 'Approved';
        case RequisitionApprovalState.REJECTED:
          return 'Rejected';
      }
    }
  }
});
